import {Injectable} from "@angular/core";
import {HttpParams} from "@angular/common/http";

import {Observable} from "rxjs";
import {UserModel} from "../../../models/user.model";
import {ApiService} from "./api.service";
import {PaginatedTypedListResponse} from "../../../interfaces/responses";

@Injectable({
    providedIn: "root",
})
export class UsersService {
    constructor(private _apiService: ApiService) {
    }

    getUsers(
        page: number,
        perPage: number,
        sortField: string,
        sortOrder: string,
        search: string,
        role: string,
    ): Observable<PaginatedTypedListResponse<UserModel>> {
        let params = new HttpParams()
            .set("page", page.toString())
            .set("perPage", perPage)
            .set("sortField", sortField)
            .set("sortOrder", sortOrder);

        if (search) {
            params = params.set("search", search);
        }
        if (role) {
            params = params.set("role", role);
        }
        return this._apiService.get<PaginatedTypedListResponse<UserModel>>(
            `users`,
            {params},
        );
    }

    create(user: UserModel): Observable<UserModel> {
        return this._apiService.post<UserModel>(`users`, user);
    }

    update(id: number, user: Partial<UserModel>): Observable<UserModel> {
        return this._apiService.patch<UserModel, Partial<UserModel>>(`users/${id}`, user);
    }

    delete(id: number): Observable<void> {
        return this._apiService.delete<void>(`users/${id}`);
    }
}
